<template>
  <div>
    <b-table :data="dataTable" :bordered="true" :striped="true">
        <b-table-column field="reference"
                        :label="$t('remiseBancaire.ajoutReglementPiece.referencePiece')"
                        v-slot="props">
          <router-link-blank v-if="pieceAsLink(props.row)"
            :to="getUrlPiece(props.row)"
            :message="props.row.referencePiece"
          /> <span v-else>{{props.row.referencePiece}}</span>
        </b-table-column>
        <b-table-column field="typeDePiece" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.typePiece')">
          <span>{{ props.row.pieceType }}</span>
        </b-table-column>
        <b-table-column field="dateEcheance" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.datePiece')">
          <span>{{props.row.datePiece | formatDate}}</span>
        </b-table-column>
        <b-table-column field="montant" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.totalPiece')"
                        cell-class="right">
          <span>{{props.row.montantPieceTtc | formatDevise}}</span>
        </b-table-column>
        <b-table-column field="escompte" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.escompte')"
                        cell-class="right">
          <span>{{props.row.montantEscompte | formatDevise}}</span>
        </b-table-column>
        <b-table-column field="inputLetterage" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.inputAffecte')"
                        cell-class="right">
          {{props.row.inputAffecte | formatDevise}}
        </b-table-column>
        <b-table-column field="solde" v-slot="props"
                        :label="$t('remiseBancaire.ajoutReglementPiece.soldePiece')"
                        cell-class="right">
          <span>{{getSoldePiece(props.row) | formatDevise}}</span>
        </b-table-column>
      <template slot="footer">
        <div class="has-text-left">
          {{ $t('remiseBancaire.nonLettre') }}
          <span class="has-text-weight-bold">{{ resteALettrer | formatDevise}}</span>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { SENS_VENTE } from '@/configuration/devisConf';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import getMouvementInfos from '@/services/remiseBancaire/reglement/mouvementClientReglement';
import { createNamespacedHelpers } from 'vuex';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    data: Object,
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      dataTable: [],
      resteALettrer: 0,
      vente: SENS_VENTE,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getUrlPiece(piece) {
      switch (piece.pieceType) {
        case (mouvementClientConf.REGLEMENT):
          return {
            name: 'c.bodac.remises_bancaires',
            params: { id: piece.remiseBancaire.id },
          };
        default:
          return {
            name: 'c.bodac.factures',
            params: { id: piece.pieceId },
          };
      }
    },
    pieceAsLink(piece) {
      return piece.pieceType === mouvementClientConf.FACTURE
        || piece.pieceType === mouvementClientConf.AVOIR
        || piece.pieceType === mouvementClientConf.ACOMPTE
        || piece.pieceType === mouvementClientConf.REGLEMENT;
    },
    getSoldePiece(piece) {
      if (piece === null) return 0.0;
      if (piece.escompteApplicable === true) {
        return piece.restantALettrerTtc - piece.inputAffecte - piece.montantEscompte;
      }
      return piece.restantALettrerTtc - piece.inputAffecte;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const mouvementClientReglement = await getMouvementInfos(this.data, this.societeActiveId);
      this.dataTable = mouvementClientReglement.dataTable;
      this.resteALettrer = mouvementClientReglement.resteALettrer;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>

<style>
</style>
